import React from "react";
import Settingpage from "Pages/Setting";


const Settingtheme = () => {
  return (
    <React.Fragment>
      <Settingpage/>  
    </React.Fragment>
  );
};

export default Settingtheme;
